import React from 'react';
import brain from './Brain.jpg';
import Tilt from 'react-tilt';

const Logo = () => {
    return(
        <div className="ma4 mt0">
            <Tilt className = {`Tilt`} options = {{max: 150}}>
                <div className="Tilt-inner pa3">
                    <img className= "Tilt__image" src= {brain} alt = "Hogwarts img" />
                </div>
            </Tilt>
        </div>
    );
}

export default Logo